import { createContext, useContext } from "react"
import { IProjectContextProvider } from "../types";

export const ProjectContextProviderContext = createContext(null as IProjectContextProvider);

export function useProjectContextProviderContext() {
    return useContext(ProjectContextProviderContext);
}